import * as React from 'react';
import StarIcon from '@material-ui/icons/Star'
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';


const styles = (theme: Theme) => ({
    root: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    starOff: {
        color: "#BBB"
    },
    starOn: {
        color: "orange",
    },
});

interface StarRatingProps {
    maxRating: number
    onChange: (rating: number) => void
}

interface StarRatingState {
    currentRating: number;
}

type WithStylesProps = "root" | "starOn" | "starOff";
type AllProps = StarRatingProps & WithStyles<WithStylesProps>

class StarRating extends React.Component<AllProps, StarRatingState> {

    constructor(props: AllProps) {
        super(props);

        this.state = {
            currentRating: 0
        }

        this.handleClick = this.handleClick.bind(this);
        this.handleHover = this.handleHover.bind(this);
    }

    public render() {
        const { maxRating, classes } = this.props;
        const { currentRating } = this.state;

        const items = [];
        for (let i = 0; i < maxRating; i++) {
            const rate = i + 1;

            const item = <Grid item key={rate}>
                <IconButton
                    onClick={(e) => this.handleClick(rate)}
                >
                    <StarIcon
                        className={currentRating >= rate ? classes.starOn : classes.starOff}
                    />
                </IconButton>
            </Grid >

            items.push(item);
        }

        return <Grid container direction="row" spacing={2} className={classes.root}>
            {items}
        </Grid>
    }

    private handleHover(rating: number) {
        this.setState({
            currentRating: rating
        });

        // this.props.onRatingChanged(rating);
    }

    private handleClick(rating: number) {
        this.setState({
            currentRating: rating
        });

        this.props.onChange(rating);
    }
}

export default withStyles(styles)(StarRating);


// WEBPACK FOOTER //
// ./src/feedback/components/StarRating.tsx